// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Classes */\n.input-container {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
